var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeerGroupName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDEFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6666 11H14.3333M18.5 20.1667C18.2636 19.2157 17.2341 18.5 16 18.5C14.7658 18.5 13.7363 19.2157 13.5 20.1667M16 15.1667H16.0083M12.8333 23.5H19.1666C20.1 23.5 20.5668 23.5 20.9233 23.3183C21.2369 23.1586 21.4919 22.9036 21.6516 22.59C21.8333 22.2335 21.8333 21.7667 21.8333 20.8333V11.1667C21.8333 10.2332 21.8333 9.76653 21.6516 9.41002C21.4919 9.09641 21.2369 8.84144 20.9233 8.68166C20.5668 8.5 20.1 8.5 19.1666 8.5H12.8333C11.8999 8.5 11.4332 8.5 11.0766 8.68166C10.763 8.84144 10.5081 9.09641 10.3483 9.41002C10.1666 9.76653 10.1666 10.2332 10.1666 11.1667V20.8333C10.1666 21.7667 10.1666 22.2335 10.3483 22.59C10.5081 22.9036 10.763 23.1586 11.0766 23.3183C11.4332 23.5 11.8999 23.5 12.8333 23.5ZM16.8333 15.1667C16.8333 15.6269 16.4602 16 16 16C15.5397 16 15.1666 15.6269 15.1666 15.1667C15.1666 14.7064 15.5397 14.3333 16 14.3333C16.4602 14.3333 16.8333 14.7064 16.8333 15.1667Z",
    stroke: "#2C3E4B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerGroupName);
export default __webpack_public_path__ + "static/media/peer-group-name.caa70a7aed131e070750048108fda104.svg";
export { ForwardRef as ReactComponent };